import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation RemoveClusterOccupant(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $employeeId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                removeClusterOccupant(
                  clusterId: $clusterId
                  employeeId: $employeeId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.RemoveClusterOccupantMutation,
  undefined,
  graphql.schema.RemoveClusterOccupantMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
